import type { PropsWithChildren } from "react";
import { createContext } from "react";

export interface Props {
  selectedContentName: string;
}

const PageContainerContext = createContext<Props | undefined>(undefined);

export const PageContainerContextProvider = ({ children, ...props }: PropsWithChildren<Props>) => (
  <PageContainerContext value={props}>{children}</PageContainerContext>
);

export default PageContainerContext;
